module.exports = __webpack_public_path__ + "static/media/studio.a0d936d2.png";